import Vue from 'vue'

window.Bus = new Vue()

export default Bus
